<template>
    <div>
        <h5 class="uppercase mb-1" v-text="label"></h5>
        <multiselect
            v-if="chosenSubscriptionId"
            class="w-full sm:w-2/3 mx-auto"
            v-model="chosenSubscriptionId"
            label="address"
            :placeholder="$t('SELECT_SUBSCRIPTION')"
            :allow-empty="false"
            :show-labels="false"
            :options="subscriptions"/>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';

export default {
    name: 'SubscriptionDropdown',
    props: {
        label: {
            default: 'Box delivered to:',
            type: String,
        },
        subscriptionId: {
            default: null,
            type: Number,
        },
    },
    methods: {
        /**
         * Map the given subscription into a consistent format for comparison in vue multiselect.
         *
         * @param {*} subscription
         *
         * @returns {{address: *, id: *}}
         */
        mapSubscription(subscription) {
            return {
                id: subscription.id,
                address: this.getAddressById(subscription.delivery_address_id).address1,
            };
        },
    },
    computed: {
        ...mapGetters({
            activeSubscriptions: 'subscription/getActiveSubscriptions',
            getActiveSubscription: 'subscription/getActiveSubscription',
            getAddressById: 'address/getAddressById',
        }),

        subscriptionById() {
            return this.$store.getters['subscription/getSubscriptionById'](this.subscriptionId);
        },

        chosenSubscriptionId: {
            get() {
                if (this.subscriptionId) {
                    return this.mapSubscription(this.subscriptionById);
                }

                return this.getActiveSubscription ? this.mapSubscription(this.getActiveSubscription) : null;
            },
            set(subscription) {
                return this.$store.commit('subscription/setActiveSubscriptionId', subscription.id);
            },
        },

        subscriptions() {
            return this.activeSubscriptions.map(subscription => this.mapSubscription(subscription));
        },
    },
    components: {
        Multiselect,
    },
};
</script>
